import AppModal from '@components/AppModal';
import Text from '@components/Text';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useLogout from './hooks/useLogout';

declare module '@stackflow/config' {
    interface Register {
        LogoutModal: {};
    }
}

const LogoutModal: ActivityComponentType<'LogoutModal'> = () => {
    const { t } = useTranslation('accountSetting');
    const logout = useLogout();
    return (
        <AppModal title={t('logoutModal.title')}
            deny={t('logoutModal.cancel')}
            confirm={t('logoutModal.confirm')}
            onConfirm={logout} >
            <Text size='title' align='center'>{t('logoutModal.message')}</Text>
        </AppModal>
    );
};

export default LogoutModal;
